module.exports = __webpack_public_path__ + "img/icon_download_static.e80c576b.png";